export const JOIN = {
  TITLE_A: 'Join the making of',
  TITLE_B: 'a new world!',
  BODY: 'Take part in the conversation, stay in the know, share your ideas & be the first to hear about every update.',
}
